import { SectionKey } from "./types";

export const SECTION_LABELS: Record<SectionKey, string> = {
  snapshotQueue: "Financial snapshots",
  backfillQueue: "Price backfills",
  coverageImpact: "Price coverage",
  schedulers: "Schedulers",
  todo: "Pending work",
};
